__turbopack_context__.v({
  "category": "MobileMenu-module-scss-module__NGpdtq__category",
  "category-container": "MobileMenu-module-scss-module__NGpdtq__category-container",
  "category-image": "MobileMenu-module-scss-module__NGpdtq__category-image",
  "category-link": "MobileMenu-module-scss-module__NGpdtq__category-link",
  "category-link-content": "MobileMenu-module-scss-module__NGpdtq__category-link-content",
  "close-button": "MobileMenu-module-scss-module__NGpdtq__close-button",
  "container": "MobileMenu-module-scss-module__NGpdtq__container",
  "menu-link": "MobileMenu-module-scss-module__NGpdtq__menu-link",
  "menu-section": "MobileMenu-module-scss-module__NGpdtq__menu-section",
  "mobile-menu": "MobileMenu-module-scss-module__NGpdtq__mobile-menu",
  "section-heading": "MobileMenu-module-scss-module__NGpdtq__section-heading",
  "section-text": "MobileMenu-module-scss-module__NGpdtq__section-text",
  "text": "MobileMenu-module-scss-module__NGpdtq__text",
  "trigger-button": "MobileMenu-module-scss-module__NGpdtq__trigger-button",
});
